export const UiActionTypes = {
  UI_LANGUAGE_MODIFY: "UI/UI_LANGUAGE_MODIFY",

  // Load custom THEME
  UI_GET_THEME_CONFIG_LOADING: "UI/UI_GET_THEME_CONFIG_LOADING",
  UI_GET_THEME_CONFIG_SUCCESS: "UI/UI_GET_THEME_CONFIG_SUCCESS",
  UI_GET_THEME_CONFIG_FAILED: "UI/UI_GET_THEME_CONFIG_FAILED",
};
